import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sw_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Retries briefly while the server is restarting (e.g. right after a publish).
const SAFE = [502, 503, 520, 521, 522, 523, 525, 526, 530];
const canRetry = (cfg, st) => (cfg.method === "get" ? !st || st >= 502 : SAFE.includes(st));
api.interceptors.response.use(null, async (err) => {
  const cfg = err.config;
  const st = err.response?.status;
  if (!cfg || !canRetry(cfg, st) || (cfg._tries || 0) >= 5) return Promise.reject(err);
  cfg._tries = (cfg._tries || 0) + 1;
  await new Promise((r) => setTimeout(r, 1500 * cfg._tries));
  return api(cfg);
});

export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const links = (c) => ({
  tel: `tel:${c?.phone_raw || ""}`,
  sms: `sms:${c?.phone_raw || ""}`,
  wa: `https://wa.me/${c?.whatsapp_raw || ""}?text=${encodeURIComponent(`Hello ${c?.brand || "StripWise"}, I'd like to sell supplies`)}`,
  mail: `mailto:${c?.email || ""}`,
  mail2: `mailto:${c?.email2 || ""}`,
});

// Rotates the visible live-chat agent every 24h (UTC day), always shown online.
export const todaysAgent = (c) => {
  const list = (c?.chat_agents || []).filter((a) => a?.name);
  if (list.length) return list[Math.floor(Date.now() / 86400000) % list.length];
  return { name: c?.chat_agent_name || `${c?.brand || "StripWise"} Support`, photo: c?.chat_agent_photo };
};
